module.exports = __webpack_public_path__ + "media/logistics.3e301166.mp4";